import { Horizontal } from './components/Horizontal';

const WizardsPage = () => (
  <>
    
    <Horizontal />
  </>
);

export default WizardsPage;